import { combineEpics } from "redux-observable";
import "./views/common/epics/index.js";
import "./views/Create/epics/index.js";
import "./views/View/epics/index.js";
import "./views/List/epics/index.js";
import { capacitySearchContextEpics } from "./views/capacity/CapacitySearchContext.js";
import { rootEpic as rootEpic$1 } from "./views/common/epics/epics.js";
import { rootEpic as rootEpic$2 } from "./views/Create/epics/epics.js";
import { rootEpic as rootEpic$3 } from "./views/View/epics/epics.js";
import { rootEpic as rootEpic$4 } from "./views/List/epics/epics.js";
const rootEpic = combineEpics(rootEpic$1, rootEpic$2, rootEpic$3, rootEpic$4, capacitySearchContextEpics);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
